import { resetIdentity } from './heap'

export function navigateToPublicRoute(
  href: string,
  softNavigate: (href: string) => void,
): void {
  if (!window.heap) {
    softNavigate(href)
    return
  }
  // Heap cannot be stopped in place; only a full page load ends capture.
  resetIdentity()
  window.location.assign(href)
}

export function endCaptureIfLoaded(): void {
  if (!window.heap) return
  resetIdentity()
  window.location.replace(window.location.href)
}
